/**
 * The frame dimensions the catalog records, in the order a temple prints them: 52-18-140.
 *
 * These three are a partial description of a frame. They say nothing about total width, lens height, wrap or the shape of the bridge, and nothing at all about the wearer's head. Matching them is a dimension match, never a fitting.
 */
export const Dimension = {
  LENS_WIDTH: 'LENS_WIDTH',
  BRIDGE_WIDTH: 'BRIDGE_WIDTH',
  TEMPLE_LENGTH: 'TEMPLE_LENGTH',
} as const;
export type Dimension = (typeof Dimension)[keyof typeof Dimension];

/** Lens width, bridge, temple — the printed order, which is also the order reasons list them in. */
export const DIMENSIONS: readonly Dimension[] = [
  Dimension.LENS_WIDTH,
  Dimension.BRIDGE_WIDTH,
  Dimension.TEMPLE_LENGTH,
];

/** A range in whole millimetres. Both ends are included. */
export interface MmRange {
  readonly minMm: number;
  readonly maxMm: number;
}

export type DimensionRanges = Readonly<Partial<Record<Dimension, MmRange>>>;
export type DimensionValues = Readonly<Partial<Record<Dimension, number>>>;

/** What a catalog frame records, each value in whole millimetres or null when not recorded. */
export interface FrameDimensions {
  readonly lensWidthMm: number | null;
  readonly bridgeWidthMm: number | null;
  readonly templeLengthMm: number | null;
}

export const frameDimensionValue = (
  frame: FrameDimensions,
  dimension: Dimension,
): number | null => {
  switch (dimension) {
    case Dimension.LENS_WIDTH:
      return frame.lensWidthMm;
    case Dimension.BRIDGE_WIDTH:
      return frame.bridgeWidthMm;
    case Dimension.TEMPLE_LENGTH:
      return frame.templeLengthMm;
  }
};
